import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  box-shadow: 3px 3px 9px 3px rgba(229, 233, 240, 0.3);
  border-radius: 8px;
  overflow: hidden;

  --col-span: 2;

  width: calc(100% / var(--col-span)) - calc(16px / var(--col-span));

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    --col-span: 3;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    --col-span: 5;
  }
`;

export const CoverImageContainer = styled.div`
  width: 100%;
  min-width: 100%;
  max-width: 300px;
  height: 120px;
`;

export const PropertyInfosContainer = styled.div`
  padding: 20px;
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;
